import type { FC } from 'react';

import { Loader } from '../Loader';
import { Root } from './styles';
import type { LoadingOverlayProps } from './types';

export const LoadingOverlay: FC<LoadingOverlayProps> = (props) => (
  <Root ownerState={props}>
    <Loader />
  </Root>
);
